/** Helper function that takes an existing orderby object and makes an odata filter */
export const makeOdataOrderBy = (orderBy) => {
    if (!(orderBy === null || orderBy === void 0 ? void 0 : orderBy.key)) {
        return null;
    }
    return `$orderBy=${orderBy.key} ${orderBy.ascending ? 'asc' : 'desc'}`;
};
